// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginPage_formContainer__00Nq2","formRow":"LoginPage_formRow__+PP91","error":"LoginPage_error__I1JL9","registerLink":"LoginPage_registerLink__a36aH"};